import { Directive, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';

@Directive({
	standalone: true,
	selector: '[fileChange]'
})
export class FileChangeDirective implements OnInit, OnDestroy {
	private destroy$ = new Subject<void>();

	@Input('fileChange') fileChangeHandler: (event: Event, files: FileList) => void;

	constructor(private el: ElementRef) { }

	ngOnInit(): void {
		// Ensure the fileChangeHandler is a function
		if (typeof this.fileChangeHandler !== 'function') {
			console.error('fileChange input must be a function');
			return;
		}
	}

	@HostListener('change', ['$event'])
	onChange(event: Event): void {
		const inputElement = this.el.nativeElement as HTMLInputElement;
		if (inputElement.files) {
			this.fileChangeHandler(event, inputElement.files);
		}
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}